<script setup>
import { reactiveOmit } from "@vueuse/core";
import { Primitive } from "reka-ui";
import { cn } from "@/shared/lib/utils";
import { badgeVariants } from ".";

const props = defineProps({
  variant: { type: String, default: undefined },
  class: { type: [String, Object, Array], default: undefined },
  as: { type: [String, Object], default: undefined },
  asChild: { type: Boolean, default: undefined },
});

const delegatedProps = reactiveOmit(props, "class");
</script>

<template>
  <Primitive
    data-slot="badge"
    :class="cn(badgeVariants({ variant }), props.class)"
    v-bind="delegatedProps"
  >
    <slot />
  </Primitive>
</template>
